export const ACCOUNT_TYPES = {
  INDIVIDUAL: 'INDIVIDUAL',
  ENTITY: 'ENTITY',
  ALTO_IRA: 'AltoIRA', // not confirmed against backend — not currently submitted anywhere (disabled/"Coming Soon" option)
};

export const ENTITY_TYPE_OPTIONS = ['Revocable Trust', 'Irrevocable Trust', 'Limited Partnership', 'LLC', 'Corporation'];

export const ENTITY_DOCUMENT_TYPE_OPTIONS = [
  'Articles of Incorporation',
  'Certificate of Formation',
  'Abstract of Trust',
  'Certificate of Good Standing',
  'Other',
];

// Maps the human-readable label shown in the UI to the docType enum value the backend expects
// (used for both the pre-signed-url request and the entityDocType sent on profile update).
export const ENTITY_DOCUMENT_TYPE_VALUES = {
  'Articles of Incorporation': 'ArticlesOfIncorporation',
  'Certificate of Formation': 'CertificateOfFormation',
  'Abstract of Trust': 'AbstractOfTrust',
  'Certificate of Good Standing': 'CertificateOfGoodStanding',
  Other: 'Other',
};

// Sent as the `platform` query param on entity document pre-signed-url requests.
export const ENTITY_DOC_UPLOAD_PLATFORM = 'Entity';

// Only the stage backend accepts `platform`; other environments reject it via whitelist validation.
export const IS_ENTITY_DOC_PLATFORM_ENABLED = process.env.REACT_APP_ENTITY_DOC_PLATFORM_ENABLED === 'true';

// Short acronym per document type, used only to build the indexed file name sent to the
// pre-signed-url request (e.g. AOI1, AOI2, ...) — NOT sent as the docType value itself.
export const ENTITY_DOCUMENT_TYPE_SHORT_CODES = {
  'Articles of Incorporation': 'AOI',
  'Certificate of Formation': 'COF',
  'Abstract of Trust': 'AOT',
  'Certificate of Good Standing': 'COGS',
  Other: 'OTH',
};

// Shared between onboarding (EntityDocs.js) and Profile > Edit Entity Information
// (EditEntityDetails.js) — both must stay in sync on how many entity documents a user may add.
export const MAX_ENTITY_DOCUMENTS = 5;

// Shared notification key so the document-limit toast doesn't stack when several files are selected at once.
export const ENTITY_DOC_LIMIT_TOAST_KEY = 'entity-doc-limit';

// Shared notification key for the toast shown when an already-added document is selected again.
export const ENTITY_DOC_DUPLICATE_TOAST_KEY = 'entity-doc-duplicate';
